module.exports = __webpack_public_path__ + "img/course97.c743d678.png";